var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedconcilIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "MedConcil app icon, dark theme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    rx: 26,
    fill: "#138980"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 71.5 25.7 49.4C18.4 42.2 18.3 31.6 25.2 25.2C31.9 18.9 42.4 21.3 48 28.1C53.6 21.3 64.1 18.9 70.8 25.2C77.7 31.6 77.6 42.2 70.3 49.4L48 71.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 4.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 46.1H39.0L43.8 40.5 49.1 52.7 56.0 36.3 61.2 46.1H68.3",
    stroke: "#FFFFFF",
    strokeWidth: 4.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedconcilIconDark);
export default __webpack_public_path__ + "static/media/medconcil_icon_dark.13e0c59f0da9ce80e08bf7e434496c30.svg";
export { ForwardRef as ReactComponent };